import snakecaseKeys from 'snakecase-keys'

// GETリクエスト用にオブジェクトをJSONにしてURLエンコード
export const encodeGetParams = <T>(params: T) => {
  const json = JSON.stringify(snakecaseKeys(params, { deep: true }))

  return encodeURIComponent(json)
}

// テキスト内からリンクを抽出してaタグで囲む
export const addLinkOnText = (text: string, target = '_blank') => {
  return text.replace(
    /(https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+)/,
    `<a href="$1" class="changed-link" target="${target}">$1</a>`
  )
}
